module.exports = {
  productionLicenses:	'Production Licenses',
  testLicense: 'Test License',
  totalActive: 'Total number of Active Licenses',
  totalConcurrent: 'Total number of Concurrent Users',
  registeredUsers: 'Registered Users',
  active: 'Active',
  inactive: 'Inactive',
  domains: 'Domains',
  webSpaceTypes: 'Web space types',
  premium: 'Premium',
  basic: 'Basic',
  link: 'Link',
  custom: 'Custom',
  orders: '# orders',
  totalAmount: 'Total Amount',
  webShopRes: 'WebShop Resources',
  category: 'Category',
  module: 'Module',
  users: '# of users',
  moon: 'Moon',
  paymentM: 'Payment Management',
  contactM:	'Contact Management',
  reportsM: 'Reports Management',
  ordertM: 'Order Management',
  invoiceM: 'Invoice Management',
  inventoryM: 'Inventory Management',
  drawerHandlerM: 'Drawer Handler Management',
  DBOptM: 'DB Optimization Management',
  moonBackupM: 'Moon Backup Management',
  sun: 'Sun',
  autoJobM: 'Auto Job Management',
  catalogM: 'Catalog Management',
  printerM: 'Printer Management',
  printServerM:	'Print Server Management',
  licenseM: 'License Management',	
  tableM: 'Table Management',
  accountM:	'Account Management',
  companyM: 'Company Management',
  sunBackupM: 'Sun Backup Management',
  userCounts: 'User Counts By License Type',
  type: 'Type',
  companyName: 'Company Name',
  concUsers: '# of concurrent users',
  activeUsers: '# of active users',
  domainsByWSType: 'Domains By Web Space Type',
  domainNames: 'Domain Names',
  webShopResourceByType: 'Webshop Resources By Type',
  ActiveWebShopResources: 'Active Web Shop Resources',
  InactiveWebShopResources: 'Inactive Web Shop Resources',
  webShopResourceId: 'Webshop Resource ID',
  webShopResourceName: 'Webshop Resource Name',
}


// WEBPACK FOOTER //
// ./src/lang/en/license.js